(() => {
// Enhanced galleries keep their current frame visible until the next responsive image is decoded.
const h01Products=new Set(['9667825041647','9667825500399','9667953098991']);
const h01Root=element=>{const root=element?.closest?.('[data-group-product-section]');return root&&h01Products.has(root.dataset.groupProduct)&&root.querySelector('[data-group-picker]')?.dataset.groupFamily==='H01'?root:null;};
const nextGalleryProducts=new Set(["9669108138223","9563801125103","9565749870831","9563801157871","9563801092335","9563801026799","9667739877615","9669107974383","9667740467439","9667807740143","9667809444079","9667810427119","9667811475695","9667817963759","9667818684655","9667819176175","9667819995375","9667820683503","9667821076719","9667777396975","9667778216175","9667779002607","9667779887343","9667951526127","9667780804847","9667784507631","9667785490671","9667787325679","9667788407023","9667789914351","9667790930159","9667804365039","9667755966703","9667806003439","9667825041647","9667953098991","9667825500399","9669108302063","9669107745007","9497629098223","9497300467951","9497590825199","9497459556591","9667823960303","9667826090223","9497301057775"]);
const nextGalleryRoot=element=>{const root=element?.closest?.('[data-ready-gallery]');return root&&nextGalleryProducts.has(root.dataset.readyGallery)?root:null;};
const galleryRoot=element=>nextGalleryRoot(element)||h01Root(element);
const imageRequests=new Map();
const imageSpec=image=>({src:image?.getAttribute('src')||'',srcset:image?.getAttribute('srcset')||'',sizes:image?.getAttribute('sizes')||''});
const imageKey=spec=>JSON.stringify([spec.src,spec.srcset||'',spec.sizes||'']);
const cacheImage=(key,image,promise)=>{imageRequests.set(key,{image,promise});if(imageRequests.size>12)imageRequests.delete(imageRequests.keys().next().value);};
const prepareImage=(spec,priority='low')=>{
 if(!spec?.src)return Promise.reject(new Error('gallery_image_missing'));
 const key=imageKey(spec);
 const existing=imageRequests.get(key);
 if(existing){if(priority==='high')existing.image.fetchPriority='high';return existing.promise;}
 const image=new Image();image.decoding='async';image.loading='eager';image.fetchPriority=priority;
 const promise=new Promise((resolve,reject)=>{
  let settled=false,decoding=false;
  const finish=error=>{if(settled)return;settled=true;clearTimeout(timeout);image.removeEventListener('load',loaded);image.removeEventListener('error',failed);if(error){imageRequests.delete(key);reject(error);}else resolve(image);};
  const loaded=async()=>{if(settled||decoding)return;decoding=true;try{if(!image.naturalWidth)throw new Error('gallery_image_empty');if(image.decode)await image.decode();finish();}catch(error){finish(error);}};
  const failed=()=>finish(new Error('gallery_image_failed'));
  const timeout=setTimeout(()=>finish(new Error('gallery_image_timeout')),15000);
  image.addEventListener('load',loaded);image.addEventListener('error',failed);
  if(spec.sizes)image.sizes=spec.sizes;
  if(spec.srcset)image.srcset=spec.srcset;
  image.src=spec.src;
  if(image.complete)loaded();
 });
 // Image-only cache is bounded; price, inventory and purchase forms are never cached here.
 cacheImage(key,image,promise);
 return promise;
};
window.mobaiH01Media={prepare:prepareImage,fromImage:imageSpec};
let galleryRequest=0;
const thumbSpec=(button,image)=>({src:button.dataset.image,srcset:button.dataset.imageSrcset||'',sizes:button.dataset.imageSizes||image?.getAttribute('sizes')||''});
const galleryStatus=(root,busy,message='')=>{
 const frame=root.querySelector('.main-image');frame?.setAttribute('aria-busy',String(busy));
 const status=root.querySelector('[data-gallery-status]');if(status){status.textContent=message;status.hidden=!message;}
};
const reducedGalleryData=()=>navigator.connection?.saveData||/^(slow-)?2g$/.test(navigator.connection?.effectiveType||'');
const rememberDisplayedImage=image=>{
 if(!nextGalleryRoot(image)||!image.complete||!image.naturalWidth)return;
 const key=imageKey(imageSpec(image));if(imageRequests.has(key))return;
 const promise=Promise.resolve().then(()=>image.decode?.()).then(()=>image);
 cacheImage(key,image,promise);
 promise.catch(()=>{if(imageRequests.get(key)?.image===image)imageRequests.delete(key);});
};
const warmNextGallery=()=>{
 const root=galleryRoot(document.querySelector('#mobai-main-image'));if(!root)return;
 const image=root.querySelector('#mobai-main-image');
 const warm=()=>{
  if(!root.isConnected||document.hidden||!image.complete||!image.naturalWidth||reducedGalleryData())return;
  rememberDisplayedImage(image);
  const buttons=[...root.querySelectorAll('.thumbnails [data-image]')],active=buttons.findIndex(button=>button.classList.contains('active')),next=buttons[active+1];
  if(next)prepareImage(thumbSpec(next,image),'low').catch(()=>{});
 };
 const schedule=()=>{if(window.requestIdleCallback)window.requestIdleCallback(warm,{timeout:1500});else setTimeout(warm,250);};
 if(image.complete&&image.naturalWidth)schedule();else image.addEventListener('load',schedule,{once:true});
};
const prepareGalleryIntent=event=>{
 if(event.type==='pointerover'&&event.pointerType!=='mouse')return;
 const button=event.target.closest?.('.thumbnails [data-image]');const root=galleryRoot(button);
 if(nextGalleryRoot(button)){
  if(button.classList.contains('active')||reducedGalleryData())return;
  rememberDisplayedImage(root.querySelector('#mobai-main-image'));
 }
 if(root)prepareImage(thumbSpec(button,root.querySelector('#mobai-main-image')),'low').catch(()=>{});
};
['pointerover','pointerdown','focusin'].forEach(type=>document.addEventListener(type,prepareGalleryIntent,{passive:true}));
const showGallery=async button=>{
 const root=galleryRoot(button),image=root?.querySelector('#mobai-main-image');if(!image)return;
 const request=++galleryRequest,spec=thumbSpec(button,image),frame=root.querySelector('.main-image');
 rememberDisplayedImage(image);
 if(button.classList.contains('active')){galleryStatus(root,false);return;}
 galleryStatus(root,true,frame?.dataset.galleryLoading||'');
 try{
  const prepared=await prepareImage(spec,'high');
  if(request!==galleryRequest||!root.isConnected)return;
  if(nextGalleryRoot(button)){
   // Reuse decoded nodes, including the original first frame, without changing a visible src.
   for(const attribute of image.attributes){if(!['src','srcset','sizes','loading','fetchpriority','decoding','alt','data-zoom-src'].includes(attribute.name))prepared.setAttribute(attribute.name,attribute.value);}
   prepared.dataset.zoomSrc=button.dataset.imageZoomSrc||spec.src;prepared.alt=button.dataset.alt||'';
   image.replaceWith(prepared);
  }else{
   if(spec.sizes)image.setAttribute('sizes',spec.sizes);
   if(spec.srcset)image.setAttribute('srcset',spec.srcset);else image.removeAttribute('srcset');
   image.src=spec.src;image.dataset.zoomSrc=button.dataset.imageZoomSrc||spec.src;image.alt=button.dataset.alt||'';
  }
  root.querySelectorAll('.thumbnails [data-image]').forEach(item=>{item.classList.toggle('active',item===button);item.setAttribute('aria-pressed',String(item===button));});
  galleryStatus(root,false);caption();warmNextGallery();
 }catch(error){if(request===galleryRequest&&root.isConnected)galleryStatus(root,false,frame?.dataset.galleryFailed||'');}
};
document.addEventListener('mobai:product-choice',()=>{++galleryRequest;warmNextGallery();});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',warmNextGallery,{once:true});else warmNextGallery();
const loadCardHover=(event)=>{
 if(event.type==='pointerover'&&(event.pointerType!=='mouse'||!matchMedia('(hover: hover) and (pointer: fine)').matches))return;
 const media=event.target.closest?.('.card-media');
 const template=media?.querySelector('template[data-card-hover]');
 if(!template)return;
 const image=template.content.querySelector('img').cloneNode(true);
 const ready=()=>{if(image.naturalWidth>0)media.classList.add('card-hover-ready');};
 image.addEventListener('load',ready,{once:true});
 template.replaceWith(image);
 if(image.complete)ready();
};
document.addEventListener('pointerover',loadCardHover,{passive:true});
document.addEventListener('focusin',loadCardHover);
let opener=null; let activePanel=null;
const key='mobai-native-saved'; let saved=[];
try{saved=JSON.parse(localStorage.getItem(key)||'[]');if(!Array.isArray(saved))saved=[];}catch{}
const syncSaved=()=>{document.querySelectorAll('[data-save]').forEach(b=>{const yes=saved.includes(b.dataset.save);b.classList.toggle('saved',yes);b.setAttribute('aria-pressed',String(yes));});};
const renderSaved=()=>{const box=document.querySelector('[data-saved-container]');if(!box)return;box.replaceChildren();document.querySelector('#mobai-saved-catalog')?.content.querySelectorAll('[data-product-card]').forEach(card=>{if(saved.includes(card.dataset.productId))box.append(card.cloneNode(true));});document.querySelector('[data-empty-saved]').hidden=box.children.length>0;syncSaved();};
const closePanel=()=>{if(activePanel)activePanel.hidden=true;activePanel=null;document.body.style.overflow='';document.querySelector('#MainContent')?.removeAttribute('inert');opener?.focus();};
const openPanel=(name,button)=>{closePanel();activePanel=document.querySelector(`[data-panel="${name}"]`);if(!activePanel)return;opener=button;activePanel.hidden=false;document.body.style.overflow='hidden';document.querySelector('#MainContent')?.setAttribute('inert','');if(name==='saved')renderSaved();(activePanel.querySelector(name==='search'?'.drawer input':'.drawer button[data-panel-close]'))?.focus();};
const imageCaptionKind=alt=>{
 const value=typeof alt==='string'?alt.replace(/[\u064b-\u065f\u0670\u0640]/g,''):'';
 const deniesSize=/\b(?:not\s+(?:(?:a|an|the)\s+)?|no\s+)(?:size\s+guide|dimensions?\s+diagram)\b|(?:非|不是|并非)\s*(?:一张)?尺寸(?:示意)?图|(?:ليس|ليست|لا يمثل|لا تمثل)\s+(?:هذا\s+|هذه\s+)?(?:الصورة\s+)?(?:دليل|دليلا|مخطط|مخططا)\s+(?:لل|ل|ال)?[اأ]بعاد|(?:لا يستخدم|لا تستخدم)\s+(?:كدليل|كمرجع)\s+(?:لل|ل|ال)?[اأ]بعاد/i.test(value);
 const guide=/\bsize\s+guide\b|\bdimensions?\s+diagram\b|尺寸示意图|(?:دليل|مخطط|رسم توضيحي)\s+(?:لل|ل|ال)?[اأ]بعاد/i.test(value);
 const diagramOnly=/\bdiagram\s+only\b|(?:رسم توضيحي|مخطط)\s+فقط/i.test(value);
 const measuredSize=/(?:\b\d+(?:[.,]\d+)?(?:\s*[×x]\s*\d+(?:[.,]\d+)?)*\s*(?:cm|mm|inch(?:es)?|in)\b|[\d٠-٩]+(?:[.,٫][\d٠-٩]+)?(?:\s*[×x]\s*[\d٠-٩]+(?:[.,٫][\d٠-٩]+)?)*\s*سم)/i.test(value);
 const productSize=/\bproduct\s+size\b|(?:[اأ]بعاد|مقاس)\s+المنتج/i.test(value);
 if(!deniesSize&&(guide||(productSize&&diagramOnly)))return 'size';
 const photoDetail=/\bcamera[- ]photo\s+(?:detail\s+crop|partial\s+view)\b/i.test(value)&&/\bAI[-\s]+retouched\b/i.test(value);
 const chinesePhotoDetail=/(?:实拍|原片)局部/.test(value)&&/AI\s*(?:辅助)?整理/i.test(value);
 const arabicPhotoDetail=/(?:لقطة تفصيلية مقتطعة|جزء من صورة|تفصيل من الصورة الأصلية)/i.test(value)&&/(?:صورة فوتوغرافية أصلية|الصورة الأصلية)/i.test(value)&&/الذكاء الاصطناعي/i.test(value);
 if(photoDetail||chinesePhotoDetail||arabicPhotoDetail)return 'detail';
 const ai=/\bAI\b|AI\s*(?:辅助|生成|整理)|الذكاء الاصطناعي/i.test(value);
 if(ai&&/\bscene\b|\bstyling\b|场景|مشهد|مشاهد/i.test(value))return 'scene';
 if(!deniesSize&&productSize&&measuredSize)return 'size';
 if(/illustrat|\bscene\b|\bstyling\b|示意图|场景|توضيح|مشهد|مشاهد/i.test(value))return 'illustration';
 if(ai)return 'illustration';
 return '';
};
const caption=()=>{
 const im=document.querySelector('#mobai-main-image');
 const c=document.querySelector('[data-image-caption]');
 if(!c)return;
 if(c.hasAttribute('data-product-image-captions')){
  const selected=document.querySelector('.thumbnails [data-image].active');
  const label=selected?.dataset.productCaption||c.dataset.productImageCaption||'';
  c.textContent=label;c.hidden=!label;c.removeAttribute('data-caption-kind');return;
 }
 const kind=im?imageCaptionKind(im.alt):'';
 const label=kind?c.getAttribute(`data-caption-${kind}`):'';
 c.textContent=label||'';
 c.hidden=!label;
 if(label)c.setAttribute('data-caption-kind',kind);
 else c.removeAttribute('data-caption-kind');
};
document.addEventListener('mobai:product-image-change',caption);
const heroSlides=[...document.querySelectorAll('[data-hero-slide]')];
if(heroSlides.length>1&&heroSlides.every(slide=>slide.parentElement===heroSlides[0].parentElement)){
 const carousel=document.createElement('div');
 carousel.className='mobai-home-carousel';
 heroSlides[0].before(carousel);
 heroSlides.forEach(slide=>{slide.setAttribute('aria-hidden',String(slide.hidden));carousel.append(slide);});
}
let heroTimer,heroRequest=0,heroPaused=false,heroHover=false,heroFocused=false,heroDragging=false;
let heroInteracted=false;
const heroMotion=matchMedia('(prefers-reduced-motion: reduce)');
const heroButtons=()=>document.querySelectorAll('[data-hero-autoplay]');
const syncHeroControls=()=>heroButtons().forEach(button=>{const paused=heroPaused||heroMotion.matches;button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.resumeLabel:button.dataset.pauseLabel;});
const stopHero=()=>{clearTimeout(heroTimer);heroTimer=undefined;};
const scheduleHero=()=>{
 stopHero();
 if(heroSlides.length<2||!heroInteracted||heroPaused||heroHover||heroFocused||heroDragging||heroMotion.matches||document.hidden)return;
 if(window.mobaiOpeningGate?.active){heroTimer=setTimeout(scheduleHero,250);return;}
 heroTimer=setTimeout(()=>{const index=heroSlides.findIndex(slide=>!slide.hidden);showHero(heroSlides[(index+1)%heroSlides.length].dataset.heroSlide,false,true);},6000);
};
const heroStartEvents=['pointerdown','keydown','wheel','click'];
const startHeroAfterInteraction=event=>{
 if(heroInteracted||!event.isTrusted||document.hidden||window.mobaiOpeningGate?.active)return;
 heroInteracted=true;
 heroStartEvents.forEach(type=>document.removeEventListener(type,startHeroAfterInteraction,true));
 scheduleHero();
};
if(heroSlides.length>1)heroStartEvents.forEach(type=>document.addEventListener(type,startHeroAfterInteraction,{capture:true,passive:true}));
const prepareHero=(slide,priority='low')=>{
 const template=slide.querySelector('template[data-hero-media]');
 if(template){const fragment=template.content.cloneNode(true);const image=fragment.querySelector('img');if(image){image.loading='eager';image.fetchPriority=priority;}template.replaceWith(fragment);}
 const image=slide.querySelector('.hero-image img');
 if(!image)return Promise.resolve(false);
 if(priority==='high')image.fetchPriority='high';
 if(image.complete)return Promise.resolve(image.naturalWidth>0);
 return new Promise(resolve=>{let settled=false;const finish=ok=>{if(settled)return;settled=true;clearTimeout(timeout);image.removeEventListener('load',loaded);image.removeEventListener('error',failed);resolve(ok);};const loaded=()=>finish(image.naturalWidth>0);const failed=()=>finish(false);const timeout=setTimeout(()=>finish(false),6000);image.addEventListener('load',loaded,{once:true});image.addEventListener('error',failed,{once:true});});
};
let heroWarmPending=false;
const warmHeroNeighbor=()=>{
 if(heroWarmPending||heroSlides.length<2||navigator.connection?.saveData||/^(slow-)?2g$/.test(navigator.connection?.effectiveType||''))return;
 const current=heroSlides.find(slide=>!slide.hidden),image=current?.querySelector('.hero-image img');
 if(!image)return;
 if(!image.complete){image.addEventListener('load',warmHeroNeighbor,{once:true});return;}
 if(!image.naturalWidth)return;
 heroWarmPending=true;
 const warm=()=>{
  heroWarmPending=false;
  if(document.hidden||window.mobaiOpeningGate?.active)return;
  const index=heroSlides.findIndex(slide=>!slide.hidden);
  if(index>=0)void prepareHero(heroSlides[(index+1)%heroSlides.length]);
 };
 if(window.requestIdleCallback)window.requestIdleCallback(warm,{timeout:1200});else setTimeout(warm,250);
};
window.addEventListener('mobai-opening-state',warmHeroNeighbor);
const showHero=async(target,focus=false,automatic=false)=>{
 const slide=heroSlides.find(item=>item.dataset.heroSlide===String(target));if(!slide)return;
 stopHero();const request=++heroRequest;
 const ready=await prepareHero(slide,automatic?'low':'high');
 if(request!==heroRequest)return;
 if(automatic&&(!heroInteracted||heroPaused||heroHover||heroFocused||heroDragging||heroMotion.matches||document.hidden||window.mobaiOpeningGate?.active)){scheduleHero();return;}
 if(ready){heroSlides.forEach(item=>{item.hidden=item!==slide;item.setAttribute('aria-hidden',String(item.hidden));});if(focus)slide.querySelector(`[data-hero-target="${target}"]`)?.focus();warmHeroNeighbor();}
 scheduleHero();
};
// Pointer gestures share the existing image readiness and stale-request protection.
let heroGesture=null,heroSuppressClickUntil=0,heroSuppressLinkUntil=0;
const clearHeroGesture=()=>{
 const gesture=heroGesture;heroGesture=null;heroDragging=false;
 if(!gesture)return;
 gesture.slide.classList.remove('is-pointer-dragging');
 if(gesture.slide.hasPointerCapture?.(gesture.id))gesture.slide.releasePointerCapture(gesture.id);
};
const cancelHeroGesture=()=>{if(heroGesture?.link)heroSuppressLinkUntil=Date.now()+400;clearHeroGesture();scheduleHero();};
const beginHeroGesture=(event,slide)=>{
 if(event.isPrimary===false){cancelHeroGesture();return;}
 const control=event.target.closest('a,button,input,select,textarea,[contenteditable]');
 const link=control?.matches('a[data-hero-link]')?control:null;
 if(heroSlides.length<2||slide.hidden||event.button!==0||(control&&!link))return;
 clearHeroGesture();++heroRequest;stopHero();heroDragging=true;
 heroGesture={id:event.pointerId,slide,link,index:heroSlides.indexOf(slide),x:event.clientX,y:event.clientY,axis:null,prepared:false};
 if(!link)try{slide.setPointerCapture(event.pointerId);}catch{/* A cancelled pointer must not block navigation. */}
};
const moveHeroGesture=event=>{
 const gesture=heroGesture;if(!gesture||gesture.id!==event.pointerId)return;
 const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
 if(!gesture.axis&&Math.max(Math.abs(dx),Math.abs(dy))>12){
  if(Math.abs(dx)>Math.abs(dy)*1.35)gesture.axis='horizontal';
  else if(Math.abs(dy)>=Math.abs(dx))gesture.axis='vertical';
 }
 if(gesture.link&&gesture.axis)heroSuppressLinkUntil=Date.now()+400;
 if(gesture.axis!=='horizontal')return;
 gesture.slide.classList.add('is-pointer-dragging');
 if(!gesture.prepared){
  if(gesture.link)try{gesture.slide.setPointerCapture(gesture.id);}catch{}
  gesture.prepared=true;
  const next=(gesture.index+(dx*(document.documentElement.dir==='rtl'?-1:1)<0?1:-1)+heroSlides.length)%heroSlides.length;
  void prepareHero(heroSlides[next],'high');
 }
};
const finishHeroGesture=event=>{
 const gesture=heroGesture;if(!gesture||gesture.id!==event.pointerId)return;
 const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
 const threshold=45;
 if(gesture.link&&(gesture.axis||Math.max(Math.abs(dx),Math.abs(dy))>12))heroSuppressLinkUntil=Date.now()+400;
 clearHeroGesture();
 if(gesture.axis!=='horizontal'||Math.abs(dx)<threshold||Math.abs(dx)<=Math.abs(dy)*1.35){scheduleHero();return;}
 heroPaused=true;syncHeroControls();heroSuppressClickUntil=Date.now()+400;
 const next=(gesture.index+(dx*(document.documentElement.dir==='rtl'?-1:1)<0?1:-1)+heroSlides.length)%heroSlides.length;
 void showHero(heroSlides[next].dataset.heroSlide);
};
document.addEventListener('pointermove',moveHeroGesture,{passive:true});
document.addEventListener('pointerup',finishHeroGesture,{passive:true});
document.addEventListener('pointercancel',event=>{if(heroGesture?.id===event.pointerId)cancelHeroGesture();},{passive:true});
document.addEventListener('pointerdown',event=>{if(event.isPrimary===false)cancelHeroGesture();},{passive:true});
document.addEventListener('click',event=>{
 if(event.detail!==0&&((Date.now()<heroSuppressClickUntil&&event.target.closest('[data-hero-slide]'))||(Date.now()<heroSuppressLinkUntil&&event.target.closest('a[data-hero-link]')))){event.preventDefault();event.stopImmediatePropagation();}
},true);
window.addEventListener('blur',cancelHeroGesture);
heroSlides.forEach(slide=>{
 slide.addEventListener('mouseenter',()=>{heroHover=true;stopHero();});
 slide.addEventListener('mouseleave',()=>{heroHover=false;scheduleHero();});
 slide.addEventListener('focusin',()=>{heroFocused=true;stopHero();});
 slide.addEventListener('focusout',event=>{if(!heroSlides.some(item=>item.contains(event.relatedTarget))){heroFocused=false;scheduleHero();}});
 slide.addEventListener('pointerdown',event=>beginHeroGesture(event,slide),{passive:true});
 slide.addEventListener('dragstart',event=>event.preventDefault());
});
document.addEventListener('visibilitychange',()=>{scheduleHero();if(!document.hidden)warmHeroNeighbor();});
window.addEventListener('pagehide',()=>{clearHeroGesture();++heroRequest;stopHero();});
heroMotion.addEventListener('change',()=>{syncHeroControls();scheduleHero();});
syncHeroControls();scheduleHero();warmHeroNeighbor();

document.addEventListener('click',e=>{const b=e.target.closest('button,a');if(!b)return;
if(b.matches('[data-panel-open]'))openPanel(b.dataset.panelOpen,b);
if(b.matches('[data-panel-close]'))closePanel();
if(b.matches('[data-save]')){saved=saved.includes(b.dataset.save)?saved.filter(v=>v!==b.dataset.save):[...saved,b.dataset.save];try{localStorage.setItem(key,JSON.stringify(saved));}catch{}syncSaved();if(activePanel?.dataset.panel==='saved')renderSaved();}
if(b.matches('[data-quantity-step]')){const input=b.closest('.quantity').querySelector('input');const min=Number(input.min||1);input.value=Math.max(min,(Number(input.value)||min)+Number(b.dataset.quantityStep));input.dispatchEvent(new Event('change',{bubbles:true}));}
if(b.matches('[data-hero-target]'))showHero(b.dataset.heroTarget,true);
if(b.matches('[data-hero-autoplay]')){heroPaused=!heroPaused;heroFocused=false;syncHeroControls();scheduleHero();}
if(b.matches('[data-home-tab]')){document.querySelectorAll('[data-home-tab]').forEach(tab=>{const yes=tab===b;tab.setAttribute('aria-selected',String(yes));document.getElementById(tab.dataset.homeTab).hidden=!yes;});}
if(b.matches('[data-image]')){if(galleryRoot(b))showGallery(b);else{const im=document.querySelector('#mobai-main-image');if(b.dataset.imageSrcset)im.srcset=b.dataset.imageSrcset;else im.removeAttribute('srcset');im.src=b.dataset.image;im.dataset.zoomSrc=b.dataset.imageZoomSrc||b.dataset.image;im.alt=b.dataset.alt;document.querySelectorAll('[data-image]').forEach(x=>{x.classList.toggle('active',x===b);x.setAttribute('aria-pressed',String(x===b));});caption();}}
if(b.matches('[data-image-zoom],[data-hairpin-detail-zoom]')){const dialog=document.querySelector('[data-zoom-dialog]');const im=document.querySelector('#mobai-main-image');const zoomImage=dialog?.querySelector('img');if(dialog&&im&&zoomImage){zoomImage.src=b.dataset.hairpinDetailZoom||im.dataset.zoomSrc||im.currentSrc||im.src;zoomImage.alt=b.dataset.detailAlt||im.alt;dialog.showModal();}}
if(b.matches('[data-zoom-close]'))document.querySelector('[data-zoom-dialog]').close();
if(b.matches('[data-grid]')){document.querySelectorAll('[data-grid]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const grid=document.querySelector('.collection-grid');grid.classList.toggle('large',b.dataset.grid==='large');grid.classList.toggle('normal',b.dataset.grid==='normal');}
if(b.matches('[data-filter-close]')){document.querySelector('.filters').classList.remove('open');const toggle=document.querySelector('[data-filter-toggle]');toggle.setAttribute('aria-expanded','false');toggle.focus();}
if(b.matches('[data-filter-toggle]')){const open=document.querySelector('.filters').classList.toggle('open');b.setAttribute('aria-expanded',String(open));}
});
document.addEventListener('change',e=>{if(e.target.matches('[data-sort]')){const url=new URL(location.href);url.searchParams.set('sort_by',e.target.value);url.searchParams.delete('page');location.assign(url.href);}if(e.target.matches('[data-variant-select]')){const v=e.target.selectedOptions[0];const available=v.dataset.available==='true';document.querySelector('[data-product-price]').textContent=v.dataset.price;const stock=document.querySelector('[data-stock]');stock.textContent=available?stock.dataset.inStock:stock.dataset.soldOut;const add=document.querySelector('[data-add-button]');add.disabled=!available;add.textContent=available?add.dataset.addLabel:add.dataset.soldOutLabel;const url=new URL(location.href);url.searchParams.set('variant',v.value);history.replaceState({},'',url);}});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&activePanel)closePanel();if(e.key==='Tab'&&activePanel){const els=[...activePanel.querySelectorAll('.drawer a,.drawer button,.drawer input,.drawer select')].filter(x=>!x.disabled&&x.getClientRects().length);const first=els[0],last=els.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}}});
const initRandomRecommendations=(scope=document)=>{
 const selector='[data-random-recommendations]';
 const sections=scope.matches?.(selector)?[scope]:[...scope.querySelectorAll(selector)];
 for(const section of sections){
  if(section.dataset.recommendationsInitialized==='true')continue;
  const rail=section.querySelector('[data-recommendation-rail]');
  const pools=[...section.querySelectorAll('template[data-recommendation-pool]')];
  if(!rail||!pools.length)continue;
  const currentId=section.dataset.currentProductId||'';
  const storageKey='mobai-recommendations-last:v1:'+currentId;
  let previous={};
  try{const value=JSON.parse(sessionStorage.getItem(storageKey)||'{}');if(value&&typeof value==='object'&&!Array.isArray(value))previous=value;}catch{}
  const selectedIds=new Set([currentId]);
  const next={};
  const fragment=document.createDocumentFragment();
  for(const pool of pools){
   const category=pool.dataset.recommendationPool;
   if(!category||Object.hasOwn(next,category))continue;
   const categoryIds=new Set();
   const candidates=[...pool.content.querySelectorAll('[data-product-card]')].filter(card=>{
    const id=card.dataset.productId;
    if(!id||selectedIds.has(id)||categoryIds.has(id)||card.dataset.recommendationCategory!==category||!card.querySelector('img'))return false;
    categoryIds.add(id);return true;
   });
   if(!candidates.length)continue;
   const alternatives=candidates.filter(card=>card.dataset.productId!==previous[category]);
   const choices=alternatives.length?alternatives:candidates;
   const chosen=choices[Math.floor(Math.random()*choices.length)];
   const id=chosen.dataset.productId;
   selectedIds.add(id);next[category]=id;
   fragment.append(chosen.cloneNode(true));
  }
  rail.replaceChildren(fragment);
  section.hidden=rail.childElementCount===0;
  section.dataset.recommendationsInitialized='true';
  try{sessionStorage.setItem(storageKey,JSON.stringify(next));}catch{}
 }
 syncSaved();
};
document.addEventListener('shopify:section:load',event=>initRandomRecommendations(event.target));
document.addEventListener('mobai:product-choice',event=>{
 document.querySelectorAll('[data-group-shared-recommendations] [data-random-recommendations]').forEach(section=>{section.dataset.currentProductId=event.detail.productId;delete section.dataset.recommendationsInitialized;});
 initRandomRecommendations();
});
initRandomRecommendations();
caption();syncSaved();if(location.hash==='#wechat'){const el=document.querySelector('#wechat');if(el)el.open=true;}
})();



(() => {
 if (!document.querySelector('[data-group-product-section]')) return;
 let queued = false;
 const sync = () => {
  queued = false;
  const root = document.querySelector('[data-mobai-hairpin]');
  if (!root) return;
  const purchase = root.querySelector('.product-info > .purchase');
  const header = document.querySelector('.site-header');
  const passed = matchMedia('(max-width:700px)').matches && purchase && purchase.getBoundingClientRect().bottom <= Math.max(0, header?.getBoundingClientRect().bottom || 0);
  root.toggleAttribute('data-hairpin-purchase-passed', Boolean(passed));
 };
 const queue = () => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(sync);
 };
 window.addEventListener('scroll', queue, { passive: true });
 window.addEventListener('resize', queue, { passive: true });
 window.addEventListener('load', queue, { once: true });
 document.addEventListener('mobai:product-choice', queue);
 sync();
})();


/* Reuse the existing gallery selection and localization forms. No extra image fetches. */
(() => {
  'use strict';
  const isProduct = document.querySelector('[data-mobai-product-template], #heroFrame, #mobai-main-image');
  const header = isProduct && document.querySelector('.site-header, header.header');
  if (header) {
    const form = header.querySelector('#mobai-header-language');
    // Native headers already contain the localization form in the same place as home.
    // Only the two simplified local review headers need a matching preview control.
    if (!form && document.documentElement.hasAttribute('data-mobai-local-review')) {
      const holder = document.createElement('nav');
      holder.className = 'header-right mobai-preview-header-tools';
      holder.setAttribute('aria-label', 'Language');
      const previewForm = document.createElement('form');
      previewForm.id = 'mobai-header-language';
      previewForm.className = 'mobai-language-form';
      previewForm.onsubmit = event => event.preventDefault();
      for (const [code, label] of [['en', 'English'], ['zh', '中文'], ['ar', 'العربية']]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.lang = code;
        button.dataset.reviewLanguage = code;
        if (document.documentElement.lang.startsWith(code)) button.setAttribute('aria-current', 'true');
        button.onclick = () => {
          if (parent !== window) parent.postMessage({action: 'language', lang: code}, location.origin);
          else {
            const url = new URL(location.href);
            url.searchParams.set('lang', code);
            url.pathname = url.pathname.replace(/product-(zh|en|ar)-/, `product-${code}-`);
            location.assign(url);
          }
        };
        previewForm.append(button);
      }
      holder.append(previewForm);
      header.append(holder);
    }
  }

  let start = null;
  let suppressClickUntil = 0;
  const frameFor = element => element?.closest?.('.main-image, #heroFrame');
  const thumbsFor = frame => {
    const root = frame.closest('.product-gallery, [data-ready-gallery], [data-hairpin-product]');
    return [...(root || document).querySelectorAll('.thumbnails button[data-image], #thumbs button')];
  };
  document.addEventListener('touchstart', event => {
    const frame = frameFor(event.target);
    if (!frame || event.touches.length !== 1 || frame.closest('dialog')) { start = null; return; }
    const touch = event.touches[0];
    start = {frame, x: touch.clientX, y: touch.clientY, horizontal: false, vertical: false};
  }, {passive: true});
  document.addEventListener('touchmove', event => {
    if (!start || event.touches.length !== 1) { start = null; return; }
    const dx = event.touches[0].clientX - start.x;
    const dy = event.touches[0].clientY - start.y;
    if (!start.horizontal && !start.vertical && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
      start.horizontal = Math.abs(dx) > Math.abs(dy) * 1.35;
      start.vertical = !start.horizontal;
    }
    if (start.horizontal && event.cancelable) event.preventDefault();
  }, {passive: false});
  document.addEventListener('touchend', event => {
    const gesture = start;
    start = null;
    if (!gesture || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - gesture.x;
    const dy = event.changedTouches[0].clientY - gesture.y;
    if (gesture.vertical || Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
    const buttons = thumbsFor(gesture.frame);
    if (buttons.length < 2) return;
    const selected = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true' || button.classList.contains('active')));
    const next = (selected + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length;
    suppressClickUntil = Date.now() + 450;
    buttons[next].click();
  }, {passive: true});
  document.addEventListener('touchcancel', () => { start = null; }, {passive: true});
  document.addEventListener('click', event => {
    if (Date.now() < suppressClickUntil && frameFor(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();

